import { jsx } from "react/jsx-runtime";
import CardTravelIcon from "@mui/icons-material/CardTravel";
import { validateTidalLicense } from "../../base/index.js";
function CardTravel(props) {
  return /* @__PURE__ */ jsx(
    CardTravelIcon,
    {
      "data-testid": "CardTravel",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CardTravel",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
CardTravel.tidalIconMeta = {
  categories: "chat,customerService",
  name: "CardTravel"
};
validateTidalLicense();
export {
  CardTravel
};
//# sourceMappingURL=CardTravel.js.map
